import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';

const SalesLineChart = ({ salesSku, salesQuery, salesData }) => {
	const colors = [
		'#3366CB',
		'#DC3912',
		'#F69906',
		'#7c5cdb',
		'#ce5cdb',
		'#db5c97',
		'#9fc934',
		'#60d17e',
		'#3366CB',
		'#DC3912',
		'#F69906',
		'#7c5cdb',
		'#ce5cdb',
		'#db5c97',
		'#9fc934',
		'#60d17e',
	];
	// console.log('salesQuery', salesQuery);
	const [currentData, setCurrentData] = useState([]);
	const [rowsData, setRowsData] = useState([]);
	const [labels, setLabels] = useState([]);
	const [salesName, setSalesName] = useState('Brand');

	useEffect(() => {
		if (salesData && salesData.lineData) {
			setRowsData(salesData.lineData);
		}
	}, [salesData]);

	function capitalize(str) {
		const lower = str.toLowerCase();
		return str.charAt(0).toUpperCase() + lower.slice(1);
	}

	// console.log('rowsData', rowsData);
	// console.log('salesSku', salesSku);

	useEffect(() => {
		if (salesSku && salesSku[0] && rowsData) {
			const filterSales = salesSku[0].value; // sales Quantity, Sales
			const filterCategory = salesSku[1].value; // type Brand , Chain
			// console.log('filterSales', filterSales);

			const currentData = filterCategory
				? rowsData[filterCategory]
				: rowsData['Brand'];
			if (filterCategory) {
				setSalesName(capitalize(filterCategory));
			}

			if (filterCategory && filterSales) {
				let labels;
				const data = [];
				const allData =
					currentData &&
					currentData[filterSales].map((e, i) => {
						if (e.labels) {
							labels = e.labels;
						}
						if (!e.data) return;
						data.push(e);
					});
				const mapData = data.map((e, i) => {
					return {
						label: e.label,
						fill: false,
						data: e.data,
						borderColor: colors[i], // The main line color
						pointRadius: 0,
						pointHitRadius: 10,
						borderWidth: 2,
						lineTension: 0.3,
					};
				});
				setLabels(labels);
				setCurrentData(mapData);
			} else if (filterSales || !filterSales) {
				// console.log('filterPrice2', currentData);
				let labels;
				const data = [];
				let filterD = 'Sales';
				if (filterSales) {
					filterD = filterSales;
				}

				const allData =
					currentData &&
					currentData[filterD].map((e, i) => {
						if (e.labels) {
							labels = e.labels;
						}
						if (!e.data) return;
						data.push(e);
					});
				const mapData = data.map((e, i) => {
					return {
						label: e.label,
						fill: false,
						data: e.data,
						borderColor: colors[i], // The main line color
						pointRadius: 0,
						pointHitRadius: 10,
						borderWidth: 2,
						lineTension: 0.3,
					};
				});
				setLabels(labels);
				setCurrentData(mapData);
			}
		}
	}, [rowsData, salesSku]);

	const data = {
		labels: labels,
		datasets: currentData,
	};

	var options = {
		scales: {
			// yAxes: [
			// 	{
			// 		ticks: {
			// 			beginAtZero: true,
			// 		},
			// 		scaleLabel: {
			// 			display: true,
			// 			labelString: 'Moola',
			// 			fontSize: 20,
			// 		},
			// 	},
			// ],
			y: {
				suggestedMin: -1,
			},
			x: {
				ticks: {
					maxTicksLimit: 10,
				},
			},
		},
		plugins: {
			title: {
				display: true,
				text: salesName,
				font: {
					size: '20px',
				},
			},
			legend: { display: true },
		},
		maintainAspectRatio: false,
	};

	// console.log('currentData', currentData);

	return (
		<div>
			<Line data={data} options={options} width={300} height={450} />
		</div>
	);
};

export default SalesLineChart;
